import { render } from "./ProfileModal.vue?vue&type=template&id=79a70c43&scoped=true"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=79a70c43&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a70c43"]])

export default __exports__